import icons from "../icons";

export const authFormOption = [
  { title: "ایرانی", value: true },
  { title: "غیرایرانی", value: false },
];

export const businessFormOption = [
  { title: "حقیقی", value: true },
  { title: "حقوقی", value: false },
];

export const settlementSettingOption = [
  { title: "دستی", value: 2 },
  { title: "اتوماتیک", value: 1 },
];

export const settlementScheduleOption = [
  { value: 1, title: "روزانه" },
  { value: 2, title: "هفتگی" },
  { value: 3, title: "ماهانه" },
];
export const weekOption = [
  { value: 1, title: "شنبه" },
  { value: 2, title: "یکشنبه" },
  { value: 3, title: "دوشنبه" },
  { value: 4, title: "سه‌شنبه" },
  { value: 5, title: "چهارشنبه" },
  { value: 6, title: "پنجشنبه" },
  { value: 7, title: "جمعه" },
];

export const authIranianItems = [
  { title: "تصویر آواتار", value: "profile_picture", active: true },
  { title: "کارت ملی", value: "top_national_card_image", active: false },
  {
    title: "شناسنامه",
    value: "first_birth_certificate_page_image",
    active: false,
  },
];

export const authNonIranianItems = [
  { title: "تصویر آواتار", value: "profile_picture", active: true },
  { title: "گذرنامه", value: "passport_image", active: false },
];

export const businessRealItems = [
  { title: "تصویر آواتار", value: "logo", active: true },
  {
    title: "  جواز کسب (اختیاری)",
    value: "business_license_image",
    active: false,
  },
];

export const businessLegalItems = [
  { title: "تصویر آواتار", value: "logo", active: true },
  { title: "  آگهی تاسیس ", value: "announcement_image", active: false },
  {
    title: " آگهی آخرین تغیییرات",
    value: "last_announcement_image",
    active: false,
  },
  {
    title: "  جواز کسب (اختیاری)",
    value: "business_license_image",
    active: false,
  },
];

export const adminStatusList = [
  { value: "", label: "همه موارد" },
  { value: "PAID", label: "پرداخت شده" },
  { value: "PENDING", label: "در حال بررسی" },
  { value: "CANCELED", label: "لغو شده" },
];
export const userStatusList = [
  { value: "", label: "همه موارد" },
  { value: "SUBMITTED", label: "ثبت شده" },
  { value: "CANCELED", label: "لغو شده" },
];
export const activeOptions = [
  { value: true, label: "فعال", class: "text-success-60" },
  { value: false, label: "غیرفعال", class: "text-error-90" },
];

export const gatwayTicketStatusOptions = [
  {
    value: "approved",
    label: "تایید شده",
    class: "text-success-60 bg-success-10 rounded-md px-[10px] py-1",
  },
  {
    value: "pending",
    label: "درحال بررسی ",
    class:
      "text-secondary-90 bg-secondary-20 rounded-md px-[10px] py-1 min-w-[100px]",
  },
  {
    value: "denied",
    label: "رد شدع",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
];

export const settlementStateOptions = [
  { value: "", label: "همه", class: "" },
  { value: true, label: "موفق", class: "text-success-60" },
  { value: false, label: "ناموفق", class: "text-error-90" },
];
export const transactionTerminalOptions = [
  { value: "form", label: "فرم", class: "" },
  { value: "pos", label: "کارتخوان", class: "" },
  { value: "gateway", label: "درگاه", class: "" },
];
export const transactionStateOptions = [
  { value: "", label: "همه", class: "" },
  {
    value: "success",
    label: "موفق",
    class: "text-success-60 bg-success-10 rounded-md px-[10px] py-1",
  },
  {
    value: "failed",
    label: "ناموفق",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
  {
    value: "in_progress",
    label: "درحال انجام",
    class:
      "text-secondary-90 bg-secondary-20 rounded-md px-[10px] py-1 min-w-[100px]",
  },
];

export const settlementOptions = [
  {
    value: "paid",
    label: "پرداخت شده",
    class: "text-success-60 bg-success-10 rounded-md px-[10px] py-1",
  },
  {
    value: "pending",
    label: "درحال بررسی ",
    class:
      "text-secondary-90 bg-secondary-20 rounded-md px-[10px] py-1 min-w-[100px]",
  },
  {
    value: "cancelled",
    label: "رد شده",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
];
export const settlementStatusOptions = [
  { value: "", label: "همه", class: "" },
  { value: "paid", label: "پرداخت شده", class: "text-success-60" },
  {
    value: "pending_for_settlement",
    label: "درانتظار تسویه",
    class: "text-error-90",
  },
  { value: "submitted", label: "آماده تسویه", class: "text-warning-100" },
];
export const verifiedByUserOptions = [
  { value: "", label: "همه", class: "" },
  { value: true, label: "تایید", class: "text-warning-100" },
  { value: false, label: "عدم تایید", class: "text-error-90" },
];

export const gatewayTypeOptions = [
  { value: "", label: "همه", class: "" },
  { value: "gateway", label: "درگاه", class: "" },
  { value: "pos", label: "کارتخوان", class: "" },
  { value: "submitted", label: "ثبت شده", class: "" },
];

export const ExcelFormFields = [
  { label: "نام فارسی", value: "first_name_fa" },
  { label: "نام خانوادگی فارسی", value: "last_name_fa" },
  { label: "نام انگلیسی", value: "first_name_en" },
  { label: "نام خانوادگی انگلیسی", value: "last_name_en" },
  { label: "کدملی", value: "national_code" },
  { label: "تاریخ تولد", value: "birthdate" },
  { label: "ملیت", value: "is_iranian" },
  { label: "ایمیل", value: "email" },
  { label: "موبایل", value: "mobile" },
  { label: "فعال/غیرفعال", value: "active" },
  { label: "وضعیت مسدودی", value: "verified" },
  { label: "وضعیت احراز هویت", value: "banned" },
  { label: "نقش", value: "role" },
];
export const transactionsExcelFormFields = [
  { label: "همه", value: "all" },
  { label: "تاریخ پرداخت", value: "invoice_time" },
  { label: "مبلغ", value: "amount" },
  { label: "شماره کارت", value: "card_number" },
  { label: "وضعیت تراکنش", value: "transaction_state" },
  { label: "وضعیت تسویه", value: "settlement_status" },
  { label: "شماره پیگیری وندا", value: "vanda_tracking_code" },
  { label: "شناسه سفارش", value: "order_number" },
  { label: "آدرس باز گشتی", value: "reference_number" },
  { label: "نام پرداخت کننده", value: "payer_name" },
  { label: "شماره پرداخت کننده", value: "payer_mobile" },
  { label: "ایمیل پرداخت کننده", value: "payer_mail" },
  { label: "توضیحات پرداخت کننده", value: "payer_description" },
  { label: "آدرس پرداخت کننده", value: "payer_address" },
  { label: "کدملی پرداخت کننده", value: "payer_national_code" },
  { label: "کدپستی پرداخت کننده", value: "payer_postal_code" },
];

export const UserInfoTopBarList = [
  {
    id: 1,
    title: "اطلاعات شخصی",
    path: "/personalDetails",
    active: true,
    subNav: false,
  },
  {
    id: 2,
    title: "احرازهویت ",
    path: "/userauthenticationlist",
    active: false,
    subNav: false,
  },
  {
    id: 3,
    title: "کسب و کارها",
    path: "",
    active: false,
    subNav: [
      {
        id: 1,
        title: "درخواست ها",
        path: "/bussinessTicketList",
        icon: "addicon",
        active: false,
      },
      {
        id: 2,
        title: "تاییدشده ها",
        path: "/businesslist",
        icon: "addicon",
        active: false,
      },
    ],
  },
  {
    id: 3,
    title: "درگاه ها",
    path: "",
    active: false,
    subNav: [
      {
        id: 1,
        title: "درخواست ها",
        path: "/gatewayticket",
        icon: "addicon",
        active: false,
      },
      {
        id: 2,
        title: "تاییدشده ها",
        path: "/gateway",
        icon: "addicon",
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: `حساب های بانکی`,
    path: "",
    active: false,
    subNav: [
      {
        id: 1,
        title: "درخواست ها",
        path: "/accountticket",
        icon: "addicon",
        active: false,
      },
      {
        id: 2,
        title: "تاییدشده ها",
        path: "/account",
        icon: "addicon",
        active: false,
      },
    ],
  },
  {
    id: 5,
    title: "فرم ها",
    path: "",
    active: false,
    subNav: [
      {
        id: 1,
        title: "درخواست ها",
        path: "/formticket",
        icon: "addicon",
        active: false,
      },
      {
        id: 2,
        title: "تاییدشده ها",
        path: "/form",
        icon: "addicon",
        active: false,
      },
    ],
  },
  {
    id: 6,
    title: "تراکنش ها",
    path: "/transactionlist",
    active: false,
    subNav: false,
  },
];

export const withdrawFieldLabels = {
  destination_iban: "شماره شبا",
  destination_name: "صاحب حساب",
  status: "وضعیت کاربر",
  admin_status: "وضعیت ادمین",
  min_amount: "از مبلغ",
  max_amount: "تا مبلغ",
  min_created_at: "تاریخ ایجاد از",
  max_created_at: "تاریخ ایجاد تا",
  min_payment_time: "تاریخ پرداخت از",
  max_payment_time: "تاریخ پرداخت تا",
  vanda_tracking_code: "کدرهگیری",
  application: "سامانه",
};

export const statementFieldLabels = {
  min_created_at: "تاریخ ایجاد از",
  max_created_at: "تاریخ ایجاد تا",
};

export const portStepOption = [
  { title: "تنطیمات عمومی", value: 1 },
  { title: "امور مالی", value: 2 },
  { title: "تنظیم ورودی ها", value: 3 },
];

export const portAmountOption = [
  { title: "ثابت", value: true },
  { title: "متغیر", value: false },
];
export const portWageAmountOption = [
  { title: "خودم", value: true },
  { title: "مشتری", value: false },
];
export const portSettingOption = [
  { title: "اجباری", value: true },
  { title: "اختیاری", value: false },
];

export const portDefaultValues = {
  fixed_amount: false,
  form_amount: "",
  display_payer_name: false,
  is_payer_name_mandatory: false,
  display_payer_phone: false,
  is_payer_phone_mandatory: false,
  display_payer_email: false,
  is_payer_email_mandatory: false,
  display_payer_address: false,
  is_payer_address_mandatory: false,
  is_expendable: false,
  expire_time: "",
  display_expire_time: false,
  has_target_amount: false,
  target_amount: "",
  display_target_amount: false,
  is_wage_on_owner: true,
  display_wage_payer: false,
  // realbusiness_id: 0,
  // legalbusiness_id: 0,
  display_national_code: false,
  is_national_code_mandatory: false,
  display_postal_code: false,
  is_postal_code_mandatory: false,
  name: "",
  link: "",
  image: "",
  description: "",
};

export const mobileNavbarItems = [
  {
    id: 1,
    title: "کسب وکار",
    path: "/business/list",
    active: true,
    icon: "/images/businessbriefcase.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "اعلانات",
    path: "/notices",
    active: true,
    icon: "/images/notification.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "حساب بانکی",
    path: "/accounts/list",
    active: true,
    icon: "/images/cards.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "پشتیبانی",
    path: "/tickets/list",
    active: true,
    icon: "/images/customersupport.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "پروفایل",
    path: "/profile",
    active: true,
    icon: "/images/profileicon.svg",
    subNav: [],
  },
];

export const EmailNoticeSetting = [
  {
    type: "email",
    id: "settelment",
    label: "تسویه‌حساب‌ها",
    description:
      "برای هر وجهی که از حساب‌های شما خارج می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "email",
    id: "transaction",
    label: "واریز‌ها",
    description:
      "برای هر وجهی که به حساب‌های شما واریز می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "email",
    id: "login",
    label: "ورود به نرم‌افزار",
    description:
      "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "email",
    id: "news",
    label: "اخبار",
    description: "برای تمامی اخبار وندا یک اعلان دریافت خواهید کرد",
    active: false,
  },
  {
    type: "email",
    id: "announcement",
    label: "اعلانیه",
    description:
      "برای تمامی اعلانیه‌های مربوط به شما یک اعلان دریافت خواهید کرد",
    active: false,
  },
  {
    type: "email",
    id: "ticket",
    label: "تیکت",
    description: "برای پاسخ تیکت‌ها یک اعلان دریافت خواهید کرد",
    active: false,
  },
];
export const SmsNoticeSetting = [
  {
    type: "sms",
    id: "settelment",
    label: "تسویه‌حساب‌ها",
    description:
      "برای هر وجهی که از حساب‌های شما خارج می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "sms",
    id: "transaction",
    label: "واریز‌ها",
    description:
      "برای هر وجهی که به حساب‌های شما واریز می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "sms",
    id: "login",
    label: "ورود به نرم‌افزار",
    description:
      "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
    active: false,
  },
];

export const bottomNavbarItems = [
  {
    id: 1,
    title: "خانه",
    path: "/home",
    active: true,
    icon: icons.home,
    subNav: [],
  },

  {
    id: 2,
    title: "تتر",
    path: "/teter",
    active: true,
    icon: icons.teter,
    subNav: [],
  },
  {
    id: 3,
    title: "انتقال‌وجه",
    path: "/withdrawals/list",
    active: true,
    icon: icons.withdraw,
    subNav: [],
  },
  {
    id: 4,
    title: "گزارشات ",
    path: "/account/incomes",
    active: true,
    icon: icons.list,
    subNav: [],
  },
  {
    id: 5,
    title: "پروفایل",
    path: "/profile",
    active: true,
    icon: icons.setting,
    subNav: [],
  },
];

export const withdrawsFields = [
  { label: "همه", value: "all" },
  { label: "تاریخ پرداخت", value: "invoice_time" },
  { label: "مبلغ", value: "amount" },
  { label: "شماره کارت", value: "card_number" },
  { label: "وضعیت تراکنش", value: "transaction_state" },
  { label: "وضعیت تسویه", value: "settlement_status" },
  { label: "شماره پیگیری وندا", value: "vanda_tracking_code" },
  { label: "شناسه سفارش", value: "order_number" },
  { label: "آدرس باز گشتی", value: "reference_number" },
  { label: "نام پرداخت کننده", value: "payer_name" },
  { label: "شماره پرداخت کننده", value: "payer_mobile" },
  { label: "ایمیل پرداخت کننده", value: "payer_mail" },
  { label: "توضیحات پرداخت کننده", value: "payer_description" },
  { label: "آدرس پرداخت کننده", value: "payer_address" },
  { label: "کدملی پرداخت کننده", value: "payer_national_code" },
  { label: "کدپستی پرداخت کننده", value: "payer_postal_code" },
];

export const withdrawAdminStatusOptions = [
  { value: "", label: "همه", class: "" },
  { value: "PAID", label: "پرداخت شده", class: "" },
  { value: "PENDING", label: "در انتظار پرداخت", class: "" },
  { value: "CANCELED", label: "لغو شده", class: "" },
];
export const withdrawStatusOptions = [
  { value: "", label: "همه", class: "" },
  { value: "SUBMITTED", label: "ثبت شده", class: "" },
  { value: "CANCELED", label: "لغو شده", class: "" },
];

export const withdrawAdvanceSearchDefaultValues = {
  destination_iban: "",
  destination_name: "",
  admin_status: "",
  status: "",
  min_amount: "",
  max_amount: "",
  min_created_at: "",
  max_created_at: "",
  min_payment_time: "",
  max_payment_time: "",
  vanda_tracking_code: "",
};

export const incomeAdvanceSearchDefaultValues = {
  application: "",
  min_amount: "",
  max_amount: "",
  min_created_at: "",
  max_created_at: "",
};
export const statmentAdvanceSearchDefaultValues = {
  min_created_at: "",
  max_created_at: "",
};

export const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled ? "#F5F5F5" : "white", // Change the background color when disabled
    height: "52px",
    boxShadow: state.isDisabled ? "none" : "gray",
    borderWidth: "2px",
    borderRadius: "8px",
    borderColor: state.isDisabled ? "#F5F5F5" : "#cccccc",
    "&:hover": {
      borderColor: "#cccccc",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "white",
    color: state.isSelected ? "black" : "gray",
    borderColor: "#cccccc",
    boxShadow: state.isSelected ? "white" : "black",
    "&:hover": {
      backgroundColor: "#cccccc",
      borderColor: "#cccccc",
    },
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#a8a8a8" : "gray", // Adjust color when disabled
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "black" : "black", // Adjust color when disabled
  }),
};

export const iranianBanks = [
  { code: "ENB", name: "بانک اقتصاد نوین", src: "en" },
  { code: "ANS", name: "بانک انصار", src: "ansar" },
  { code: "IRZ", name: "بانک ایران زمین", src: "iz" },
  { code: "IRV", name: "بانک ایران و ونزوئلا", src: "ivbb" },
  { code: "AYN", name: "بانک آینده", src: "ba" },
  { code: "PAR", name: "بانک پارسیان", src: "parsian" },
  { code: "PAS", name: "بانک پاسارگاد", src: "bpi" },
  { code: "TEJ", name: "بانک تجارت", src: "tejaratbank" },
  { code: "BTT", name: "بانک توسعه تعاون", src: "tt" },
  { code: "BTS", name: "بانک توسعه صادرات ایران", src: "edbi" },
  { code: "HEK", name: "بانک حکمت ایرانیان", src: "hi" },
  { code: "KHMI", name: "بانک خاورمیانه", src: "me" },
  { code: "DEY", name: "بانک دی", src: "day" },
  { code: "REF", name: "بانک رفاه", src: "rb" },
  { code: "SAM", name: "بانک سامان", src: "sb" },
  { code: "BSP", name: "بانک سپه", src: "sepah" },
  { code: "SAR", name: "بانک سرمایه", src: "sarmayeh" },
  { code: "SIN", name: "بانک سینا", src: "sina" },
  { code: "SHR", name: "بانک شهر", src: "shahr" },
  { code: "BSI", name: "بانک صادرات ایران", src: "bsi" },
  { code: "BSM", name: "بانک صنعت و معدن", src: "bim" },
  { code: "RES", name: "بانک قرض الحسنه رسالت", src: "resalat" },
  { code: "MHR", name: "بانک قرض الحسنه مهر ایران", src: "mehriran" },
  { code: "GHA", name: "بانک قوامین", src: "ghbi" },
  { code: "BKA", name: "بانک کارآفرین", src: "kar" },
  { code: "BKV", name: "بانک کشاورزی ایران", src: "bki" },
  { code: "GAR", name: "بانک گردشگری", src: "tourism" },
  { code: "BMK", name: "بانک مسکن", src: "maskan" },
  { code: "MEL", name: "بانک ملت", src: "mellat" },
  { code: "BMI", name: "بانک ملی ایران", src: "bmi" },
  { code: "NOR", name: "بانک نور", src: "noorbank" },
  { code: "PST", name: "پست بانک", src: "post" },
  {
    code: "MET",
    name: "موسسه اعتباری توسعه",
    src: "creditinstituteofdevelopment",
  },
  {
    code: "ASKC",
    name: "موسسه مالی اعتباری عسکریه",
    src: "askariyehfinanceandcreditinstitution",
  },
  {
    code: "KSAC",
    name: "موسسه مالی اعتباری کوثر",
    src: "kosarfinanceandcreditinstitution",
  },
  { code: "MEH", name: "بانک مهر اقتصاد", src: "mehreqtesadbank" },
];
